<script setup lang="ts">
  import DetailSection from "./DetailSection.vue";
  import DetailItem from "./DetailItem.vue";
  import type { Histo } from "@/components/Admin/Histo/HistoDataTable/types";

  defineProps<{
    histo: Histo;
  }>();
</script>

<template>
  <DetailSection title="Questionnaire">
    <DetailItem
      label="Type"
      :value="histo.survey_type" />
    <DetailItem
      label="Topic"
      :value="histo.hs_topic" />
    <li class="flex flex-col">
      <span class="font-medium text-foreground mb-1">Summary</span>
      <span class="text-foreground/80 leading-relaxed">{{ histo.gpt_summary || "--" }}</span>
    </li>
  </DetailSection>
</template>
